/**
 * Mesure d'audience soumise au consentement (catégorie « analytics »).
 * Aucun script n'est chargé tant que l'utilisateur n'a pas accepté ; « Tout refuser » ou une révocation
 * stoppe la collecte et efface l'identifiant. Désactivé si REACT_APP_POSTHOG_KEY est absent.
 */
import cookieConsent from '@/lib/cookieConsent';

const KEY = process.env.REACT_APP_POSTHOG_KEY;
const HOST = process.env.REACT_APP_POSTHOG_HOST || 'https://eu.i.posthog.com';
let loading = false;

function load() {
  if (loading || !KEY || window.__posthog) return;
  loading = true;
  const s = document.createElement('script');
  s.src = `${HOST}/static/array.js`;
  s.async = true;
  s.onload = () => {
    const ph = window.posthog;
    if (!ph) return;
    ph.init(KEY, { api_host: HOST, person_profiles: 'identified_only', disable_session_recording: true });
    window.__posthog = ph;
    if (!cookieConsent.has('analytics')) ph.opt_out_capturing();
  };
  s.onerror = () => { loading = false; };
  document.head.appendChild(s);
}

function apply(state) {
  if (!KEY) return;
  if (state.analytics) {
    if (window.__posthog) window.__posthog.opt_in_capturing(); else load();
  } else if (window.__posthog) {
    window.__posthog.opt_out_capturing();
    window.__posthog.reset();
  }
}

export function initAnalytics() {
  if (typeof window === 'undefined' || !KEY) return;
  apply(cookieConsent.get());
  cookieConsent.subscribe(apply);
}
